import { CSSProperties } from "react";
import { useSelectTheme } from "../../store";

export const ButtonText = (props: {
  children: React.ReactNode | string;
  onClick: (e: React.MouseEvent<HTMLButtonElement>) => void;
  textColor?: string;
  textColorWhileHovered?: string;
  backgroundColor?: string;
  backgroundColorWhileHovered?: string;
  css?: CSSProperties;
}) => {
  const { color, fontWeight, borderRadius } = useSelectTheme();
  const {
    children,
    onClick,
    textColor,
    textColorWhileHovered,
    backgroundColor,
    backgroundColorWhileHovered,
    css,
  } = props;

  return (
    <button
      onClick={onClick}
      css={{
        ...css,
        display: "inline-flex",
        alignItems: "center",
        height: "40px",
        padding: "0 16px",
        borderRadius: borderRadius.default,
        border: "none",
        backgroundColor: backgroundColor ?? "transparent",
        fontWeight: fontWeight.thick,
        color: textColor ?? color.textIcon.link,
        cursor: "pointer",
        ":hover": {
          color: textColorWhileHovered ?? color.surface.hover.blue,
          backgroundColor: backgroundColorWhileHovered ?? color.surface.blue.light,
        },
      }}
    >
      {children}
    </button>
  );
};
